import { createAction } from '@reduxjs/toolkit';

import { AuditTrailFromApi } from '../../models';

export const auditTrailOnSendingRequest = createAction('auditTrail/onSendingRequest');
export const auditTrailOnReceived = createAction<AuditTrailFromApi>('auditTrail/onReceived');
export const auditTrailOnFailed = createAction<string>('auditTrail/onFailed');
